<template>
    <div class="forum-cantainer">
        <van-nav-bar title="参加论坛" left-arrow @click-left="back"></van-nav-bar>

        <div class="content">
            <div class="forum-content">
                <div class="forum-item">
                    <div class="forum-banner">
                        <img :src="forumInfo.photo" alt />
                    </div>
                    <div class="title">{{ forumInfo.title }}</div>
                    <div class="desc">
                        <div class="forum-time">{{ textTime(forumInfo)}} </div>
                        <div class="text"> 活动地点：{{ forumInfo.holdAddress }}</div>
                    </div>

                    <div class="posts ql-snow">
                        <div class="ql-editor" v-html="forumInfo.content"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="submit" v-if="!loading">
            <div>
                <div class="total">
                    价格：
                    <span>{{ forumInfo.price }}元</span>
                </div>
                <div class="price-desc" v-html="forumInfo.priceDesc"></div>
            </div>
            <template v-if="forumInfo.status == '1'">
                <div class="btn" @click="onSubmit" v-if="!isPay">报名</div>
                <div class="btn disable" v-else>已报名</div>
            </template>
            <div class="btn disable" v-else-if="forumInfo.status == '0' ">报名暂未开放</div>

            <div class="btn disable" v-else>已结束</div>

        </div>

        <div class="home-bar" @click="onHome">
            <svg-icon icon-class="home" icon-name="home"></svg-icon>
        </div>

        <van-popup v-model="showPrompt">
            <div class="prompt-wrap ql-snow">
                <div class="ql-editor prompt-content" v-html="forumInfo.prompt"></div>
                <div class="close-prompt" @click="showPrompt = false">
                    关闭
                </div>
            </div>

        </van-popup>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
import Toast from 'vant/lib/toast';
import { SplitDate } from '@/utils/time';
export default {
    data() {
        return {
            payPrice: 0,
            forumInfo: [],
            forumOrder: null,
            isPay: false,
            loading: true,
            submitLoading: false,
            showPrompt: false,
        };
    },
    created() {
        this.getData();
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        onHome() {
            this.$router.push('/home');
        },
        textTime(item) {
            var start = item.startDate;
            var end = item.endDate;

            if (!start || !end) return '';
            try {
                const { year: startYear, month: startMonth, day: startDay } = SplitDate(start);
                const { year: endYear, month: endMonth, day: endDay } = SplitDate(end);
                if (startYear == endYear) {
                    return `${startYear}年${startMonth}月${startDay}日-${endMonth}月${endDay}日`;
                }
                return `${startYear}年${startMonth}月${startDay}日-${endYear}年${endMonth}月${endDay}日`;
            } catch {
                return '?';
            }
        },
        callpay(data) {
            if (typeof WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                    //监听没起作用
                    document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(data), false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(data));
                    document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(data));
                }
            } else {
                this.jsApiCall(data);
            }
        },
        jsApiCall(data) {
            var that = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest',
                {
                    appId: data.appId, //公众号名称，由商户传入
                    timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, //随机串
                    package: data.package,
                    signType: 'MD5', //微信签名方式
                    paySign: data.paySign, //微信签名
                },
                function (res) {
                    //我这里无论成功与否，都会跳转到我设置的页面中，且带了一个参数，用于跳转到原来的页面时给用户提示充值是否成功
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        Toast('支付成功！');
                        that.isPay = true;
                        that.getData();
                    } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                        Toast('取消支付！');
                    } else {
                        Toast(res.err_msg);
                    }
                },
            );
        },

        // 发起报名
        onSubmit() {
            if (this.submitLoading) return;
            this.submitLoading = true;
            httpRequest
                .post(`/api/forum/Payment`, {
                    openId: localStorage.getItem('v_openid'),
                    forumId: this.forumInfo.id,
                })
                .then(res => {
                    const { code, msg, data } = res.data;

                    if (code == 200) {
                        if (this.forumInfo.price > 0) {
                            this.callpay(data);
                        } else {
                            Toast.success('成功报名');
                            this.getData();
                        }
                    } else if (code == 401) {
                        Toast.fail('请先报名登录');
                        this.$store.dispatch('SetRedirectUrl', this.$router.currentRoute.fullPath);
                        this.$router.push({
                            path: '/login',
                            query: {
                                source: this.$route.query.source,
                                companyId: this.$route.query.companyId,
                                companyShareId: this.$route.query.companyShareId,
                                teamId: this.$route.query.teamId,
                            },
                        });
                    } else {
                        Toast.fail(msg);
                    }
                })
                .finally(() => {
                    this.submitLoading = false;
                });
        },

        getData() {
            var toast = this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            this.loading = true;
            httpRequest
                .get(`/api/forum/${this.$route.query.id}`)
                .then(res => {
                    const { code, data } = res.data;

                    if (code == 200) {
                        this.forumInfo = data.response;
                        this.forumOrder = data.order;
                        this.isPay = data.order == null ? false : true;
                        // if (this.forumInfo.price > 0) {
                        //   this.getCode();
                        // }
                        toast.clear();

                        if (data.response.prompt && data.response.prompt != '<p><br></p>' && this.isPay) {
                            this.showPrompt = true;
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.forum-cantainer {
    width: 100%;
    height: 100vh;
    background: #f8f8f8;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 100px;
    .content {
        .forum-content {
            padding: 5px 0 0 0;

            .forum-item {
                background: #fff;
                padding: 10px;

                .forum-banner {
                    border-radius: 5px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: auto;
                    }
                }

                .title {
                    font-weight: 500;
                    padding: 4px 0;
                }

                .text {
                }
                .posts {
                    .ql-editor {
                    }
                }
                .ql-snow {
                }

                .desc {
                    color: #999;
                    font-size: 16px;
                    padding: 4px 0;

                    .forum-time {
                        padding: 0 0 4px 0;
                    }
                    .text {
                    }

                    .forum-status {
                    }
                }
            }
        }
    }

    .submit {
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        background: #fff;
        margin-top: 20px;
        div {
            .total {
                span {
                }
            }
            .price-desc {
            }
        }

        .total {
            color: #333;
            font-size: 14px;
            span {
                color: var(--theme_primary_color);
                font-weight: bold;
            }
        }
        .btn {
            text-align: center;
            padding: 8px 0;
            background: #2062f9;
            width: 33.33%;
            border-radius: 0.13333rem;
            color: #fff;
        }
        .price-desc {
            color: #999;
            font-size: 14px;
        }

        .disable {
            background: #e6e6e6;
            color: #2062f9;
        }
    }
    .home-bar {
        position: fixed;
        right: 8px;
        bottom: 120px;
        background: rgba(0, 0, 0, 0.2);
        color: #fff;
        font-size: 32px;
        border-radius: 50%;
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
    }
    .prompt-wrap {
        margin: 8px;
        .ql-editor {
        }
        .prompt-content {
            width: 80vw;
            max-height: 80vh;
            overflow-y: scroll;
            ::v-deep img {
                width: 100%;
            }
        }
    }
    .close-prompt {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        background: #2062f9;
        color: #fff;
        margin: 20px;
    }
}

.posts {
    margin-top: 8px;
    position: relative;
    ::before {
        content: '';
        display: block;
        position: absolute;
        width: 200%; /* 或者是任何你需要的宽度 */
        height: 1px; /* 高度设置为1px */
        background-color: #eaeaea; /* 线条颜色 */
        left: 0;
        top: 0; /* 根据需求调整位置 */
        transform-origin: left center;
        transform: scale(0.5); /* 缩小至原来的一半 */
    }

    width: 100%;
    padding-top: 10px;
    ::v-deep img {
        width: 100%;
    }
}
</style>